import { render, staticRenderFns } from "./ApproveRequests.vue?vue&type=template&id=8820900a&scoped=true&"
import script from "./ApproveRequests.vue?vue&type=script&lang=js&"
export * from "./ApproveRequests.vue?vue&type=script&lang=js&"
import style0 from "./ApproveRequests.vue?vue&type=style&index=0&id=8820900a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8820900a",
  null
  
)

export default component.exports